import EmblemActiveEmployer from './EmblemActiveEmployer';
import EmblemFacebook from './EmblemFacebook';
import EmblemLinkedin from './EmblemLinkedin';
import EmblemMatchFair from './EmblemMatchFair';
import EmblemMatchGood from './EmblemMatchGood';
import EmblemMatchGreat from './EmblemMatchGreat';
import EmblemMatchPoor from './EmblemMatchPoor';
import EmblemTwitter from './EmblemTwitter';
import EmblemWebsite from './EmblemWebsite';

export { default as EmblemActiveEmployer } from './EmblemActiveEmployer';
export { default as EmblemFacebook } from './EmblemFacebook';
export { default as EmblemLinkedin } from './EmblemLinkedin';
export { default as EmblemMatchFair } from './EmblemMatchFair';
export { default as EmblemMatchGood } from './EmblemMatchGood';
export { default as EmblemMatchGreat } from './EmblemMatchGreat';
export { default as EmblemMatchPoor } from './EmblemMatchPoor';
export { default as EmblemTwitter } from './EmblemTwitter';
export { default as EmblemWebsite } from './EmblemWebsite';

export const Emblems = {
  activeEmployer: EmblemActiveEmployer,
  facebook: EmblemFacebook,
  linkedin: EmblemLinkedin,
  matchFair: EmblemMatchFair,
  matchGood: EmblemMatchGood,
  matchGreat: EmblemMatchGreat,
  matchPoor: EmblemMatchPoor,
  twitter: EmblemTwitter,
  website: EmblemWebsite,
};

export type EmblemList = keyof typeof Emblems;
